module.exports = __webpack_public_path__ + "static/img/menu2-img3.0b45dbf1.png";